import React from "react";
import { FormControlLabel, Switch } from "@mui/material";

const MODEL_OPTIONS = [{ value: "gpt-5-mini", label: "gpt-5-mini" }];

const REASONING_OPTIONS = [
  { value: "disable", label: "Disable" },
  { value: "low", label: "Low" },
  { value: "medium", label: "Medium" },
  { value: "high", label: "High" }
];

const BUILT_IN_TOOL_OPTIONS = [
  { value: "none", label: "None" },
  { value: "web_search", label: "Web search" }
];

function IntelligenceSection({
  intelligenceEnabled,
  setIntelligenceEnabled,
  model,
  setModel,
  reasoningEffort,
  setReasoningEffort,
  builtInTools,
  setBuiltInTools
}) {
  return (
    <div className="grid" style={{ gap: "12px", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))" }}>
      <FormControlLabel
        control={
          <Switch
            checked={intelligenceEnabled}
            onChange={(e) => setIntelligenceEnabled(e.target.checked)}
            inputProps={{ "aria-label": "Enable intelligence" }}
          />
        }
        label="Enable intelligence"
        sx={{ gridColumn: "1 / -1", m: 0 }}
      />

      {intelligenceEnabled && (
        <>
          <label className="field">
            <span className="label">Model</span>
            <select
              className="input"
              value={model}
              onChange={(e) => setModel(e.target.value)}
            >
              {MODEL_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </label>

          <label className="field">
            <span className="label">Reasoning effort</span>
            <select
              className="input"
              value={reasoningEffort}
              onChange={(e) => setReasoningEffort(e.target.value)}
            >
              {REASONING_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </label>

          <label className="field">
            <span className="label">Built-in tools</span>
            <select
              className="input"
              value={builtInTools}
              onChange={(e) => setBuiltInTools(e.target.value)}
            >
              {BUILT_IN_TOOL_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </label>
        </>
      )}
    </div>
  );
}

export default IntelligenceSection;
